import { render } from "./primary_button_link.vue?vue&type=template&id=598f130e&ts=true"
import script from "./primary_button_link.vue?vue&type=script&lang=ts"
export * from "./primary_button_link.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__